module.exports = __webpack_public_path__ + "img/arrow-right-blue.3df39283.svg";